import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/globals.css';
import App from './App';
import AdminApp from './components/Admin/AdminApp';

const root = createRoot(document.getElementById('root'));
const isAdmin = window.location.pathname.startsWith('/admin');
root.render(<React.StrictMode>{isAdmin ? <AdminApp /> : <App />}</React.StrictMode>);
